// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__wR5XF","welcomeBox":"style__welcomeBox__zOoBz","ids":"style__ids__DNtMA"};